import React from 'react'
import Img from "gatsby-image"
import Layout from "../layouts/pt"
import { graphql, Link } from "gatsby"

import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import SEO from '../components/seo'

import NextIcon from "../assets/next.svg"
import CircleIcon from "../assets/circle.svg"
import generateLink from '../utils/generateLink';
import * as S from '../components/Sections/Customers/Customers.styled'
import SlideTestimonial from '../components/SlideTestimonial/SlideTestimonial'

const ClientesPage = (props) => {
  return (
    <Layout location={props.location}>
      <SEO 
        title={"Clientes - WePayOut"}
        description="Veja o que nossos clientes estão falando sobre os serviços e produtos da WePayOut."
        meta={[
          { name: 'keywords', content: 'payout, fintech, wepayout' },
        ]}
        additionalBreadcrumb={{
          url: 'https://wepayout.co/pt-br/clientes',
          title: 'Clientes'
        }}
        path="https://wepayout.co/pt-br/clientes">
        <link rel="alternate" href={`https://wepayout.co/customers`} hreflang={'en'} />
        <link rel="alternate" href={`https://wepayout.co/pt-br/clientes`} hreflang={'pt-br'} />
        <link rel="alternate" href="https://wepayout.co/customers" hreflang="x-default" />
      </SEO>
      <div>
        <Header />
        
        <S.Customers>
          <div className="container">
            <div className="header">
              <h1>O que nossos clientes dizem sobre a <strong>WePayOut</strong></h1>
            </div>
          </div>
          <div className="container">

            <S.Case className="">
              <div className="product">
                <div className="product__icon"><Img fixed={props.data.pay.childImageSharp.fixed} /></div>
                <div className="product__name">Pagamentos via PIX e Transferência Bancária</div>
              </div>
              <div className="grid-case">
                <div>
                  <SlideTestimonial
                    timer={6000}
                    slides={[
                      {
                        name: "Decolar",
                        colorText: '#5a5a5a',
                        backgroundColor: "#fff",
                        backgroundImage: props.data.decolarBackground.childImageSharp.fixed,
                        logo: props.data.decolar.childImageSharp.fixed,
                        person: {
                          name: "Florencia Magnone",
                          position: "Revenue Assurance Operations Manager"
                        },
                        resume: <>
                          <p>Tínhamos um volume muito alto de devoluções a nossos clientes, dado o impacto da pandemia... e a WePayOut nos permitiu agilizar o processamento das devoluções e... torná-las instantâneas com o método PIX. Também evitou a necessidade de contato com clientes para solicitar informações de dados bancários. </p>
                        </>,
                        full: <>
                          <h5>A necessidade</h5>
                          <p>Tínhamos um volume muito alto de devoluções a nossos clientes, dado o impacto da pandemia e valores determinados pelo governo brasileiro... e não conseguimos usar um processo de devolução regular.</p>
                          <h5>Que dúvidas possuía antes da contratação?</h5>
                          <p>A questão fundamental era saber se a solução da WPO se adaptaria ao nosso problema e como fazer a conexão entre os dois negócios.</p>
                          <p>Nos deram segurança com sua disposição de adaptação e dar soluções aos problemas que apresentamos.</p>
                          <p>A proximidade da equipe WePayOut e a rapidez de suas respostas, em alguns casos até antecipar o que poderíamos consultar ou pedir para revisar, tem sido um ponto fundamental.</p>
                          <p>Também a flexibilidade para nos permitir testar o sistema, treinar-nos e fornecer-nos soluções diferentes, compreendendo realmente o problema que tínhamos como empresa.</p>
                          <h5>Os resultados</h5>
                          <p>Nos permitiu agilizar o processamento das devoluções e, em alguns casos, torná-las instantâneas com o método PIX.</p>
                          <p>Também evitou a necessidade de contato com clientes para solicitar informações de dados bancários.</p>
                          <p>O contato direto que WePayOut mantém com clientes (de forma automatizada) para casos de pagamentos rejeitados, agiliza muito nossos processos.</p>
                          <p>Com certeza sua disposição em adaptar a solução e nos ajudar nas particularidades do negócio é algo a se destacar em todo o tempo que trabalhamos.</p>
                          <h5>Você indicaria para outras pessoas o uso do produto?</h5>
                          <p>Claro que sim!</p>
                          <p>Definitivamente para qualquer empresa que precise administrar devoluções de forma ágil e prática, sem necessariamente ter os dados da conta de seus clientes. Quem quer ter certeza de em que ponto do processo se encontra cada caso (status do pagamento) e até precisa de algum processo ou ajuste ad hoc ao seu negócio.</p>
                        </>
                      },
                      {
                        name: "Cornershop",
                        colorText: '#5a5a5a',
                        backgroundColor: "#fff",
                        backgroundImage: props.data.cornershopBackground.childImageSharp.fixed,
                        logo: props.data.cornershop.childImageSharp.fixed,
                        person: {
                          name: "Rafael Leonel Gomes",
                          position: "Shopper Payments Specialist"
                        },
                        resume: <>
                          <p>A WPO otimizou nosso processo de pagamento a parceiros e nos proporcionou uma redução de gastos extremamente significativa.</p>
                          <p>Precisávamos de uma ferramenta ágil para pagamentos em massa . Utilizávamos uma plataforma de um banco comum que nos gerava um custo muito alto e um turn-over de pagamentos "baixo" e pouco maleável.</p>
                        </>,
                        full: <>
                          <h5>A necessidade</h5>
                          <p>Precisávamos de uma ferramenta ágil para pagamentos em massa . Utilizávamos uma plataforma de um banco comum que nos gerava um custo muito alto e um turn-over de pagamentos "baixo" e pouco maleável.</p>
                          <h5>Os resultados</h5>
                          <p>Apresentando o PIX como forma de pagamento principal, que por si só já é extremamente rápido, junto com uma plataforma de fácil gestão, com um produto bastante personalizável e com um custo extremamente competitivo. A WPO otimizou nosso processo de pagamento a parceiros e nos proporcionou uma redução de gastos extremamente significativa.</p>
                          <h5>Você indicaria para outras pessoas o uso do produto?</h5>
                          <p>Com certeza! Acredito que a disponibilidade para fazer mudanças na plataforma e a abertura  para discussões  foi o ponto chave para decisão em contratá-los, além da redução de custos operacionais, claro!</p>
                        </>
                      },
                      // {
                      //   name: "SkillCore",
                      //   backgroundColor: "#0e0e0e",
                      //   backgroundImage: props.data.skillcoreBackground.childImageSharp.fixed,
                      //   logo: props.data.skillcore.childImageSharp.fixed,
                      //   person: {
                      //     name: "Thiago Nascimento",
                      //     position: "Founder"
                      //   },
                      //   resume: <>
                      //     <p>Buscamos por muito tempo uma solução que pudesse automatizar nossos processos de payout dentro da SkillCore, e encontramos na WePayout o parceiro ideal para fazer isso da forma mais prática possível integrando a solução de pagamento deles dentro do nosso sistema e agilizando para que nossos usuários recebendo saques de suas contas em tempo recorde.</p>
                      //   </>,
                      //   full: <>
                      //     <p>Buscamos por muito tempo uma solução que pudesse automatizar nossos processos de payout dentro da SkillCore, e encontramos na WePayout o parceiro ideal para fazer isso da forma mais prática possível integrando a solução de pagamento deles dentro do nosso sistema e agilizando para que nossos usuários recebendo saques de suas contas em tempo recorde.</p>
                      //     <p>Desde o primeiro contato a impressão que obtivemos com a WePayout foi a melhor possível, pois entendemos claramente a visão e missão da empresa o que fez sentido total para avançarmos na parceria.</p>
                      //     <p>Não só indicaria como indico a todos que falam comigo sobre pagamentos.</p>
                      //   </>
                      // },
                      // {
                      //   name: "Logical Delivery",
                      //   backgroundColor: "#222",
                      //   backgroundImage: props.data.logicaldeliveryBackground.childImageSharp.fixed,
                      //   logo: props.data.logicaldelivery.childImageSharp.fixed,
                      //   person: {
                      //     name: "Hiago S. Souza",
                      //     position: "Tecnologia"
                      //   },
                      //   resume: <>
                      //     <p>Eu e meus sócios estávamos com muitos problemas pra fazer o processamento financeiro da empresa..com o avanço do Covid-19 esse número aumentou 300% e com isso o trabalho maçante de fazer TED's e PIX de forma manual, sujeito a erros dentre outros problemas como o tempo. Então um dia a WePayOut me apresentou a empresa e como ela funcionava e nós, claro compramos a ideia na hora.</p>
                      //   </>,
                      //   full: <>
                      //     <h5>A necessidade</h5>
                      //     <p>Eu e meus sócios estávamos com muitos problemas pra fazer o processamento financeiro da empresa, antes haviam 127 autônomos que dependiam da plataforma. Nem todos recebiam através de nós, porém grande parte sim. Com o avanço do Covid-19 esse número aumentou 300% e com isso o trabalho maçante de fazer TED's e PIX de forma manual, sujeito a erros dentre outros problemas como o tempo. Então um dia a WePayOut me encontrou, bem quando a dor era o pagamento recebemos um contato da Carol que apresentou a empresa e como ela funcionava e nós, claro compramos a ideia na hora.</p>
                      //     <h5>Os medos e receios</h5>
                      //     <p>Na realidade, eu não tive dúvidas a não ser sobre a integração com a plataforma e elas foram respondidas muito rápidas (a integração foi finalizada em 2 dias). Sobre a confiança na empresa, ela partiu pela apresentação de outros players do mercado que já faziam uso da plataforma. E claro, ter alguém pra ligar e conversar passou uma confiança enorme.</p>
                      //     <h5>Os resultados</h5>
                      //     <p>A experiência foi boa, o time é bem preparado, as API's bem documentadas e o contato é ágil. Em menos de uma semana, nós integramos, testamos e colocamos em produção.</p>
                      //     <h5>Você indicaria para outras pessoas o uso do produto?</h5>
                      //     <p>Com certeza! Vocês transmitem um profissionalismo enorme, não tive nenhum problema e é assim que todos gostam.</p>
                      //   </>
                      // },
                    ]}
                  />
                </div>
                <div>
                  <div className="content-product">
                    {/* <div className="content-product__title">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin vestibulum, libero vel vulputate vehicula.</div> */}
                    <div className="content-product__text">
                      <h3>O que são os pagamentos massivos?</h3>
                      <p>Empresas que possuem alto volume de pagamentos a terceiros, como pagamentos a entregadores, afiliados, freelances, salários, pagamentos por produtos ou serviços, ou seja, pagamentos em massa.</p>
                      <h3>Porque a WePayOut?</h3>
                      <p>A WePayOut é uma fintech, empresa de tecnologia financeira e uma instituição de pagamentos. Possui a experiência de muitos anos na indústria de processamento massivos contando com profissionais pioneiros nestas soluções no mercado brasileiro.</p>
                      <h3>Por que preciso desse produto?</h3>
                      <p>Elimine os riscos operacionais e financeiros. Acabe com o stress tecnológico de conexões com bancos. Um único pagamento para a WePayOut garante seu processamento com altíssima eficiência, rapidez e redução de custos.</p>
                      <h3>O que vem por aí</h3>
                      <p>Você deve poder escolher como e quando pagar seus beneficiários. A solução da WePayOut conta com pagamentos via PIX, transferência bancária e logo mais pagamentos para a carteira digital da WePayOut.</p>
                      <p>Os pagamentos ocorrem quando você quiser e de acordo com os dados do beneficiário que você possuir.</p>
                    </div>
                    <div className="content-product__links">
                      <Link to={generateLink({ link: '/#section-contact', locale: 'pt-br' })}><button>Entre em contato conosco para falar sobre esse produto <NextIcon /></button></Link>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="content-product__features">
                  <div className="content-product__features-column">
                    <div className="content-product__features-icon"><div><CircleIcon /></div></div>
                    <div className="content-product__features-text">
                      <h3>Tecnologia e PIX</h3>
                      <p>Uma solução tecnológica, que pode ser integrada ao seu sistema ou site via API ou Excell, que protege seus pagamentos de duplicidades e conta com um sistema de monitoramento 24x7, garantindo que os pagamentos ocorram instantaneamente, a qualquer dia da semana com a mesma segurança de sempre.</p>
                    </div>
                  </div>
                  <div className="content-product__features-column">
                    <div className="content-product__features-icon"><div><CircleIcon /></div></div>
                    <div className="content-product__features-text">
                      <h3>Dashboard</h3>
                      <p>Tenha informação sobre o status dos pagamentos em tempo real. A transparência e a visibilidade que você precisava ver.</p>
                    </div>
                  </div>
                </div>
              </div>
            </S.Case>

            <S.Case className="">
              <div className="product">
                <div className="product__icon"><Img fixed={props.data.dq.childImageSharp.fixed} /></div>
                <div className="product__name">Qualificação de dados bancários</div>
              </div>
              <div className="grid-case">
                <div>
                  <SlideTestimonial
                    slides={[
                      {
                        name: "James Delivery",
                        backgroundColor: "#984ded",
                        backgroundImage: props.data.jamesBackground.childImageSharp.fixed,
                        logo: props.data.james.childImageSharp.fixed,
                        person: {
                          name: "Patrick Winnikes",
                          position: "Head de Operações Logísticas Externas"
                        },
                        resume: <>
                          <p>Ganhamos confiança dos envolvidos com o nosso Onboarding do Entregador Parceiro James, pois os atritos financeiros que tínhamos antes, por Dados Bancários informados incorretamente ou as contas terem alguma restrição, não existem mais, já que toda a validação é antecipada e com retorno super rápido.</p>
                        </>,
                        full: <>
                          <h5>A necessidade</h5>
                          <p>Surgiu a necessidade de sermos mais assertivos com nossos Entregadores Parceiros James, para que erros e falhas nas transações bancárias fossem minimizados, através de uma validação prévia de seus Dados Bancários.</p>
                          <h5>A solução</h5>
                          <p>Buscamos antes de tudo uma ferramenta de confiança, de fácil utilização e principalmente preço atrativo. Com o recurso de Qualificação de Dados da WePayOut, pudemos testar antecipadamente os Dados Bancários informados pelos nossos Entregadores Parceiros James, através de lote via planilha. Para os caso com problemas, pudemos corrigir antes do entregador se tornar ativo na nossa plataforma, gerando menos atrito com eles.</p>
                          <h5>Os medos e receios</h5>
                          <p>Desde o começo a relação de confiança foi estabelecida, alinhando bem as expectativas de ambos os lados. Nosso maior gargalo ainda está em automatizar alguns processos e o time da WePayOut nos atendeu super bem nas demandas atuais com envio em lote via planilha, quanto nos tranquilizou para o futuro, com a integração via API.</p>
                          <h5>Os resultados</h5>
                          <p>A humanização e personalização nos atendimentos, estando de fato presente em todo nosso onboarding, com apoio e auxílio para a tomada de decisões, bem como em seguida, em usarmos a ferramenta sem nenhum problema, surpreendeu-nos positivamente por todo esse contexto. Ganhamos confiança dos envolvidos com o nosso Onboarding do Entregador Parceiro James, pois os atritos financeiros que tínhamos antes, por Dados Bancários informados incorretamente ou as contas terem alguma restrição, não existem mais, já que toda a validação é antecipada e com retorno super rápido.</p>
                          <h5>Você indicaria para outras pessoas o uso do produto?</h5>
                          <p>Com certeza indicaremos, pois os resultados obtidos até aqui foram bastante satisfatórios e adequados com a nossa expectativa e realidade.</p>
                        </>
                      },
                    ]}
                  />
                </div>
                <div>
                  <div className="content-product">
                    <div className="content-product__text">
                      <h3>Por que preciso desse produto?</h3>
                      <p>Reduza a demanda no atendimento ao cliente e aumente a taxa de conversão em pagamentos a terceiros. </p>
                      <p>O alto volume de pagamentos a terceiros pode ser desastroso se a conversão for baixa. Reclamações dos beneficiários podem impactar na imagem da empresa e afetar diretamente a evolução do negócio. Sistemas manuais sem eficiência gerando lentidão de resposta e sobrecarga na equipe de atendimento ao cliente.</p>
                      <h3>O que é qualificação de dados bancários?</h3>
                      <p>Você qualifica e valida os dados bancários antes do processamento do pagamento garantindo o maior numero de pagamentos com sucesso aos seus beneficiárias finais e diminuindo as demandas no atendimento ao cliente. </p>
                      <h3>Os dados bancários são validados antes do processamento do pagamento. Como?</h3>
                      <p>Com três níveis de qualificação: VALIDAÇÃO | SISTÊMICO | MANUAL, que evitam o processamento de pagamentos para contas que seriam rejeitadas.</p>
                      <p>As correções aplicadas são disponibilizadas via dashboard ou API, assim os dados corrigidos podem ser aplicados à sua base de dados sem necessidade de nova coreção futura.</p>
                      <h3>O que vem por aí</h3>
                      <p>A integração da funcionalidade com o sistema de pagamentos instantâneos PIX reduz o tempo de resposta.</p>
                    </div>
                    <div className="content-product__features">
                      <div className="content-product__features-column">
                        <div className="content-product__features-icon"><div><CircleIcon /></div></div>
                        <div className="content-product__features-text">
                          <h3>Tecnologia</h3>
                          <p>Integre a ferramenta ao seu próprio sistema via API ou simplesmente use-a via painel.</p>
                        </div>
                      </div>
                      <div className="content-product__features-column">
                        <div className="content-product__features-icon"><div><CircleIcon /></div></div>
                        <div className="content-product__features-text">
                          <h3>Painel</h3>
                          <p>Tenha total visibilidade de onde está a correção dos dados e aplique as novas informações em seu banco de dados. Transparência total nos dados corrigidos.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </S.Case>

            <S.Case id="remittance" className="">
              <div className="product">
                <div className="product__icon"><Img fixed={props.data.payment.childImageSharp.fixed} /></div>
                <div className="product__name">Remittance Inbound</div>
              </div>
              <div className="grid-case">
                <div>
                  <SlideTestimonial
                    slides={[
                      {
                        name: "RANA EXPRESS",
                        backgroundColor: "#1e6fad",
                        backgroundImage: props.data.ranaBackground.childImageSharp.fixed,
                        logo: props.data.rana.childImageSharp.fixed,
                        person: {
                          name: "Matheus Freire",
                          position: "Rana Express USA"
                        },
                        resume: <>
                          <p>A WePayOut é uma parceira RANA EXPRESS, é uma empresa que busca entender seu cliente e ajustar as suas demandas, ainda vai crescer muito.</p>
                        </>,
                      },
                    ]}
                  />
                </div>
                <div>
                  <div className="content-product">
                    <div className="content-product__text">
                      <h3>Porque a WePayOut?</h3>
                      <p>O processamento de pagamentos de remittances é bastante tradicional ao redor do mundo porém carece de soluções tecnológicas e redundância.</p>
                      <p>A WePayOut é uma fintech, uma empresa de tecnologia financeira, que oferece ao modelo tradicional de remittances a tecnologia que outras indústrias já aproveitam:</p>
                      <ul className="highlight">
                        <li><strong>Única integração e única due diligence</strong> conecta a remessadora com diversas instituições financeiras garantindo a redundância e a estabilidade da operação.</li>
                        <li><strong>Integração via API, FTP ou dashboard</strong>.</li>
                        <li><strong>Visibilidade nos pagamentos</strong> com relatórios de gestão de pagamentos via dashboard.</li>
                        <li><strong>Preços</strong> competitivos exigidos pela indústria.</li>
                        <li>Excelência e rapidez no <strong>acompanhamento do pagamento das ordens</strong> e na prestação do serviço incluindo customer service, compliance e fechamento dos câmbios.</li>
                      </ul>
                      <h3>O que vem por aí</h3>
                      <p>A WePayOut entende a relevância dos pagamentos de remittance para aqueles que enviam e recebem. Muito mais que um negócio, ele é uma causa social. Os recursos precisam chegar rapidamente ao beneficiário e as remessadoras precisam ter preços competitivos.</p>
                      <p>A WePayOut segue ampliando sua rede de instituições financeiras parceiras para oferecer o modelo operacional que melhor se adapta à remessadora garantindo que ela siga competitiva no mercado em que atua. Porém, o mais importante, continuará cuidando de cada pagamento com a importância que deve ter.</p>
                    </div>
                  </div>
                </div>
              </div>
            </S.Case>





            <S.Case className="">
              <div className="product">
                <div className="product__icon"><Img fixed={props.data.barcode.childImageSharp.fixed} /></div>
                <div className="product__name">Boleto bancário</div>
              </div>
              <div className="grid-case">
                <div>
                  <SlideTestimonial
                    slides={[
                      {
                        name: "Quadritech",
                        backgroundColor: "#0089bd",
                        backgroundImage: props.data.quadritechBackground.childImageSharp.fixed,
                        logo: props.data.quadritech.childImageSharp.fixed,
                        person: {
                          name: "Luiz Asmir",
                          position: "Sócio-diretor"
                        },
                        resume: <>
                          <p>Fizemos a escolha certa, nos sentimos totalmente apoiados tanto no aspecto tecnológico e integrações com nossos ambientes, como juridicamente e comercialmente, pois a WePayOut cumpre todas as regras de segurança nacionais e internacionais aplicadas a esse segmento.</p>
                        </>,
                        full: <>
                          <h5>A necessidade</h5>
                          <p>A Quadritech passou a prestar serviços de monitoramento de aulas práticas para CFCs e em função dos altos volumes de cobrança diários e necessidades de garantias de pagamento, procurou no mercado quem pudesse auxiliar na permeabilidade dos acessos de cobranças e serviços em meios de pagamentos.</p>
                          <h5>A solução</h5>
                          <p>Precisamos encontrar uma solução que tivesse abrangência nacional, que fosse de rápida implementação, que não gerasse custos marginais, que funcionasse e principalmente fosse barata. Nesse contexto surgiu a WePayOut, resolvendo todas as questões acima apresentadas.</p>
                          <h5>Os medos e receios</h5>
                          <p>Uma das preocupações eram os volumes financeiros envolvidos, o trânsito do mesmo e as reconciliações que seriam necessárias. Medo da perda do controle e evasão de recursos, porem quando vimos que a WePayOut, realizava  operações internacionais e que clientes em outras partes do mundo, realizavam as mesmas operações  que tínhamos necessidades, pensamos: ”se algumas empresas internacionais acreditam, confiam e operam, por que nós que estamos aqui do lado, falamos o mesmo idioma não poderíamos dar esse voto de confiança?”.</p>
                          <h5>Os resultados</h5>
                          <p>Hoje podemos afirmar que fizemos a escolha certa, nos sentimos totalmente apoiados tanto no aspecto tecnológico e integrações com nossos ambientes, como juridicamente e comercialmente, pois a WePayOut cumpre todas as regras de segurança nacionais e internacionais aplicadas a esse segmento, comercialmente muito competitiva, permitindo que a Quadritech possa repassar mais essa vantagem comercial em seus negócios.</p>
                        </>
                      },
                    ]}
                  />
                  
                </div>
                <div>
                  <div className="content-product">
                    {/* <div className="content-product__title">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin vestibulum, libero vel vulputate vehicula.</div> */}
                    <div className="content-product__text">
                      <p>As cobranças via boleto e o recebimento das confirmações e liquidação financeiras devem ser adequados ao seu negócio. A WePayOut tem diferentes tipos de cobrança que se adaptam ao seu modelo de operação:</p>
                      <ul>
                        <li><strong>Boleto híbrido</strong>: a aparência do boleto com a rapidez do pagamento do <strong>PIX</strong>.</li>
                        <li>Boleto rápido: <strong>notificação dos pagamentos no mesmo dia</strong>. Agilize a prestação do serviço ou a entrega do produto. </li>
                        <li>Modelo tradicional. Você <strong>aguarda até a compensação noturna</strong> e tem garantia que o pagamento foi confirmado. </li>
                      </ul>
                      <p><strong>Integração via API</strong> no seu sistema ou site para a emissão e Baixa de boletos. Sem necessidade de acesso a bancos e multi-plataformas para registro, retorno e baixa.</p>
                      <p><strong>Split de boleto</strong> do valor ou da tarifa e demonstrativo em painel no sistema de sub carteiras.</p>
                      <p><strong>Layout customizável</strong> e <strong>whitelabel</strong>, com a logo e mensagens  que desejar. Ele já é responsivo para mobile e com função copia e cola.</p>
                      <p>O <strong>painel administrativo</strong> traz todas as informações do boleto para melhor gestão operacional.</p>
                      <h3>O que vem por aí</h3>
                      <p>Acreditamos que o PIX agendado e com possibilidade de geração de multa e juros poderá substituir os boletos tradicionais.</p>
                      <p>Por isso lançamos o boleto híbrido com a aparência de um boleto tradicional, assim seus clientes não sofrem mudanças na experiência atual, e você recebe a confirmação do pagamento em até 10 segundos.</p>
                    </div>
                    {/* <div className="content-product__links">
                      <Link to={generateLink({ link: '/#section-contact', locale: intl.locale })}><button>Entre em contato conosco para falar sobre esse produto <NextIcon /></button></Link>
                    </div> */}
                  </div>
                </div>
              </div>
            </S.Case>

            <S.Case id="crossborder" className="">
              <div className="product">
                <div className="product__icon"><Img fixed={props.data.pay.childImageSharp.fixed} /></div>
                <div className="product__name">Pagamentos massivos crossborder para o Brasil</div>
              </div>
              <div className="grid-case">
                <div>
                  <SlideTestimonial
                    slides={[
                      {
                        name: "",
                        backgroundColor: "#000",
                        backgroundImage: props.data.merchantBackground.childImageSharp.fixed,
                        resume: <>
                          <p>Com a WePayOut encontramos a solução que buscávamos para poder escalar nosso programa de afiliados. Não sabíamos que existia uma solução de pagamentos cross border para o Brasil que processava pagamentos a beneficiários no mesmo dia com tanta facilidade e transparência.</p>
                        </>,
                        full: <>
                          <p>Pagar através da WePayOut trouxe todas as facilidades que vínhamos procurando há anos. Já havíamos utilizado métodos de pagamentos cross border tradicionais, porém não tínhamos a visibilidade do fluxo completo do dinheiro e não sabíamos quanto e quando os beneficiários iam efetivamente receber.</p>
                          <p>Os pagamentos com dados bancários incorretos nos causavam um problema imenso, pois estávamos expostos a novas flutuações cambiais e risco de imagem com os beneficiários.</p>
                          <p>A conversão de moedas raramente seguia o informado na plataforma dos processadores e a empresa ou os beneficiários acabavam pagando taxas ocultas.</p>
                          <p>Com a WePayOut encontramos a solução que buscávamos para poder escalar nosso programa de afiliados. Não sabíamos que existia uma solução de pagamentos cross border para o Brasil que processava pagamentos a beneficiários no mesmo dia com tanta facilidade e transparência.</p>
                          <p>Com apenas um wire tranfer para a WePayOut no Brasil, conseguimos controlar nosso saldo de conta tanto em USD ou em BRL, sem ficarmos expostos a flutuações cambiais.</p>
                          <p>Depois, somente precisamos enviar as instruções de pagamentos, que passam pela validação de dados, e são processados no mesmo dia.</p>
                          <p>Atualmente estamos conseguindo expandir nosso programa de afiliados porque podemos garantir que o pagamento ocorra com valores corretos e com a agilidade que sempre precisamos.</p>
                        </>
                      },
                    ]}
                  />
                </div>
                <div>
                  <div className="content-product">
                    <div className="content-product__text">
                      <h3>O que são os pagamentos massivos cross border?</h3>
                      <p>Alto volume de pagamentos a pessoas ou empresas, como pagamentos a afiliados, freelances, salários, pagamentos por produtos ou serviços, e que precisam ser pagos em outro país.</p>
                      <h3>Porque a WePayOut?</h3>
                      <p>A WePayOut é uma fintech, empresa de tecnologia financeira e uma facilitadora de pagamentos internacionais. Possui a experiência de muitos anos na indústria de processamento massivos contando com profissionais pioneiros nestas soluções no mercado brasileiro. </p>
                      <h3>Por que preciso desse produto?</h3>
                      <p>Pague pessoas e empresas no Brasil instantaneamente. Tenha a mesma experiência de um pagamento local, com toda a transparência na conversão de moedas e com a garantia dos valores sendo pagos corretamente aos beneficiários finais. Você escolhe a forma de pagar os beneficiários e o modelo de integração que melhor combina com seu negócio.</p>
                      <h3>Dashboard</h3>
                      <p>Tenha informação sobre o status dos pagamentos em tempo real. A transparência e a visibilidade que você precisava ver.</p>
                    </div>
                    {/* <div className="content-product__links">
                      <Link to={generateLink({ link: '/#section-contact', locale: intl.locale })}><button>Entre em contato conosco para falar sobre esse produto <NextIcon /></button></Link>
                    </div> */}
                  </div>
                </div>
              </div>
              <div>
                <div className="content-product__features">
                  <div className="content-product__features-column">
                    <div className="content-product__features-icon"><div><CircleIcon /></div></div>
                    <div className="content-product__features-text">
                      <h3>Tecnologia e PIX</h3>
                      <p>Uma solução tecnológica, que pode ser integrada ao seu sistema ou site via API ou Excell, que protege seus pagamentos de duplicidades e conta com um sistema de monitoramento 24x7, garantindo que os pagamentos ocorram instantaneamente, a qualquer dia da semana com a mesma segurança de sempre.</p>
                    </div>
                  </div>
                  <div className="content-product__features-column">
                    <div className="content-product__features-icon"><div><CircleIcon /></div></div>
                    <div className="content-product__features-text">
                      <h3>O que vem por aí</h3>
                      <p>Você deve poder escolher como e quando pagar seus beneficiários. A solução da WePayOut conta com pagamentos via PIX, transferência bancária, saques nas lotéricas e logo mais pagamentos para a carteira digital da WePayOut. Os pagamentos ocorrem quando você quiser e de acordo com os dados do beneficiário que você possuir.</p>
                    </div>
                  </div>
                </div>
              </div>
            </S.Case>




          </div>
        </S.Customers>
        
        <Footer />
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($langKey: String!) {
    site {
      siteMetadata {
        title
        authors {
          wepayout {
            avatar
            linkedin
            name
          }
          zago {
            avatar
            linkedin
            name
          }
          nunes {
            avatar
            linkedin
            name
          }
          nery {
            avatar
            linkedin
            name
          }
        }
      }
    }
    allMarkdownRemark(
      filter: { fields: { langKey: { eq: $langKey } } }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 3
    ) {
      edges {
        node {
          id
          fields {
            slug
            langKey
          }
          excerpt(truncate: true, format: PLAIN, pruneLength: 200)
          timeToRead
          frontmatter {
            date(formatString: "DD/MM/YYYY")
            title
            tags
            author
            coverImage
            shareImage
            slug
          }
        }
      }
    }
    dq: file(relativePath: { eq: "dq.png" }) {
      childImageSharp {
        fixed(width: 60) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    pay: file(relativePath: { eq: "pay.png" }) {
      childImageSharp {
        fixed(width: 60) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    payment: file(relativePath: { eq: "payment.png" }) {
      childImageSharp {
        fixed(width: 60) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    barcode: file(relativePath: { eq: "bar-code.png" }) {
      childImageSharp {
        fixed(width: 60) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    decolar: file(relativePath: { eq: "decolar-logo.png" }) {
      childImageSharp {
        fixed(width: 180) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    decolarBackground: file(relativePath: { eq: "backgroundDecolar.jpg" }) {
      childImageSharp {
        fixed(width: 1000) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    cornershop: file(relativePath: { eq: "logo-cornershop.png" }) {
      childImageSharp {
        fixed(width: 180) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    cornershopBackground: file(relativePath: { eq: "cornershopBackground.jpg" }) {
      childImageSharp {
        fixed(width: 600) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    skillcore: file(relativePath: { eq: "skillcore_color.png" }) {
      childImageSharp {
        fixed(width: 180) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    skillcoreBackground: file(relativePath: { eq: "skillcore-background.png" }) {
      childImageSharp {
        fixed(width: 600) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    quadritech: file(relativePath: { eq: "quadritech_white.png" }) {
      childImageSharp {
        fixed(width: 180) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    quadritechBackground: file(relativePath: { eq: "quadritech-background.png" }) {
      childImageSharp {
        fixed(width: 600) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    james: file(relativePath: { eq: "james_white.png" }) {
      childImageSharp {
        fixed(width: 110) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    jamesBackground: file(relativePath: { eq: "james-background.png" }) {
      childImageSharp {
        fixed(width: 600) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    merchantBackground: file(relativePath: { eq: "merchant-background.png" }) {
      childImageSharp {
        fixed(width: 600) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    rana: file(relativePath: { eq: "rana_white.png" }) {
      childImageSharp {
        fixed(width: 128) {
          ...GatsbyImageSharpFixed
        }
      }
    },
    ranaBackground: file(relativePath: { eq: "rana-background.png" }) {
      childImageSharp {
        fixed(width: 600) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    logicaldelivery: file(relativePath: { eq: "logo-white-logicaldelivery.png" }) {
      childImageSharp {
        fixed(width: 128) {
          ...GatsbyImageSharpFixed
        }
      }
    },
    logicaldeliveryBackground: file(relativePath: { eq: "wallpaper-logical-delivery.jpg" }) {
      childImageSharp {
        fixed(width: 600) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`;

export default ClientesPage